export default __webpack_public_path__ + "static/media/24-hours-not.a97f701f.svg";